export const config = {
  rowSelection: false,
  columns: [
    {title: '类型', dataIndex: 'whiteTypeName', width: 120, ellipsis: true},
    {title: '节点', dataIndex: 'nodeNameList', width: 200, ellipsis: true, render: 'nodeNameListName'},
    {title: '状态', dataIndex: 'enabledName', width: 100},
    {title: '操作', dataIndex: '#', width: 160, fixed: 'right', render: 'actionRender'},
  ],
  search: [
    {
      label: '类型',
      name: 'whiteType',
      itemType: 'select',
      data: 'whiteTypeList',
      key: 'priKey',
      labelKey: 'name',
    },
  ],
  footer: [
    {label: '新增', type: 'primary', events: ['onClick:onAdd']},
  ],
}
 